// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  tipId: __t.u64().primaryKey().name("tip_id"),
  fromIdentity: __t.identity().name("from_identity"),
  toIdentity: __t.identity().name("to_identity"),
  worldId: __t.u64().name("world_id"),
  amountSov: __t.i64().name("amount_sov"),
  at: __t.timestamp(),
});
